import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown, Type } from 'lucide-react';

const HeadingDropdown = ({ editor }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const getActiveLabel = () => {
        if (editor?.isActive('heading', { level: 1 })) return 'Heading 1';
        if (editor?.isActive('heading', { level: 2 })) return 'Heading 2';
        if (editor?.isActive('heading', { level: 3 })) return 'Heading 3';
        return 'Paragraph';
    };

    const handleSelect = (level) => {
        if (level === 'paragraph') {
            editor.chain().focus().setParagraph().run();
        } else {
            editor.chain().focus().toggleHeading({ level }).run();
        }
        setIsOpen(false);
    };

    return (
        <div className="toolbar-dropdown-container" ref={dropdownRef}>
            <button className="toolbar-action-trigger format-trigger" onClick={() => setIsOpen(!isOpen)}>
                <Type size={14} />
                <span>{getActiveLabel()}</span>
                <ChevronDown size={11} className="chevron-icon" />
            </button>
            {isOpen && (
                <div className="toolbar-dropdown-menu">
                    <button className="toolbar-dropdown-item" onClick={() => handleSelect('paragraph')}>
                        Paragraph
                    </button>
                    <button className="toolbar-dropdown-item font-semibold" onClick={() => handleSelect(1)}>
                        Heading 1
                    </button>
                    <button className="toolbar-dropdown-item font-medium" onClick={() => handleSelect(2)}>
                        Heading 2
                    </button>
                    <button className="toolbar-dropdown-item text-sm" onClick={() => handleSelect(3)}>
                        Heading 3
                    </button>
                </div>
            )}
        </div>
    );
};

export default HeadingDropdown;
